// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CTABlock_wrapper__BFIIm","title":"CTABlock_title__OXk_I","subtext":"CTABlock_subtext__p5LP6","ctaLink":"CTABlock_ctaLink__qsawT","ctaLabel":"CTABlock_ctaLabel__aqmvD"};